import { useForm } from "react-hook-form";
import { Cancelacion } from "../../models/ficha/Cancelacion"
import { InputComponent } from "../../components/InputComponent";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useEffect } from "react";

export const Cancelar = ({ urls, generic, toast, permss, id, respuesta, hideDialog }) => {
    const omodel = new Cancelacion();
    const canSrv = new MonitoreoService();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inArea } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        reset(defaultValues);
    }, [id]);

    const onSubmit = (data) => {
        data.id = id;
        canSrv.editar(data, urls).then(res => {
            generic.funcSuccess(res, toast);
            respuesta();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formgrid grid">
                    {inArea('detalle', 5, 30, 12)}
                </div>

                {generic.buttonsForms(hideDialog)}
            </form>
        </>
    )
}
